import React from 'react';
import BaseModal from '../common/BaseModal';
import CustomerSearch from './CustomerSearch';

const CustomerSelectModal = ({
  show,
  selectedCustomer,
  onCustomerSelect,
  onClose,
  onRemoveCustomer
}) => {
  const footer = (
    <>
      <button
        onClick={onClose}
        style={{
          flex: 1,
          padding: "6px 12px",
          fontSize: "12px",
          border: '1px solid var(--text-muted)', color: 'var(--text-muted)' ,
          cursor: "pointer",
          fontWeight: "600",
        }}
      >
        ❌ Anuluj
      </button>
      <button
        onClick={() => {
          onRemoveCustomer();
          onClose();
        }}
        style={{
          flex: 1,
          padding: "6px 12px",
          fontSize: "12px",
          border: '1px solid var(--danger)', color: 'var(--danger)' ,
          cursor: "pointer",
          fontWeight: "600",
        }}
      >
        🗑️ Usuń klienta
      </button>
    </>
  );

  return (
    <BaseModal
      isOpen={show}
      onClose={onClose}
      title="Wybierz klienta"
      headerIcon="👤"
      headerStyle={{ backgroundColor: "var(--info)" }}
      size="md"
      footer={footer}
      bodyStyle={{ padding: "0.75rem", maxHeight: "60vh", overflowY: "auto" }}
    >
      <CustomerSearch
        onCustomerSelect={(customer) => {
          onCustomerSelect(customer);
          onClose();
        }}
        selectedCustomer={selectedCustomer}
      />
    </BaseModal>
  );
};

export default React.memo(CustomerSelectModal);
